import type { InspectorDTO } from 'src/types/dto/inspector.dto';

type InspectorLocationFields = Pick<InspectorDTO, 'city' | 'region' | 'country'>;

/** City, state (region), and country for compact auditor location display. */
export const formatInspectorCityStateCountry = (
  inspector?: InspectorLocationFields | null
): string =>
  [inspector?.city, inspector?.region, inspector?.country]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(', ');
